import { Box, Chip, type SxProps } from '@mui/material';
import { flatSx } from '@ocodelib/mui';
import clsx from 'clsx';

interface Props {
  sx?: SxProps;
  className?: string;

  /**
   * 현재 태그
   */
  currentTag?: string;

  size?: 'small' | 'medium';

  /**
   * '전체'를 표시하려면 undefinedLabel에 '전체'로 설정하세요.
   */
  undefinedLabel?: string;

  tags: string[];

  /**
   * 변경 핸들러
   */
  onChange?: (tag?: string) => void;
}

export function TagLabels(props: Props) {
  const { sx, className, size = 'medium', tags, currentTag, undefinedLabel, onChange } = props;
  const handleChange = (tag?: string) => () => {
    onChange?.(tag);
  };

  const clickable = !!onChange;

  return (
    <Box
      className={clsx('TagLabels-root', className)}
      sx={flatSx(
        {
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap',
          ml: -0.5,
          mt: -0.5,
          '& .MuiChip-root': {
            ml: 1,
            mt: 0.5,
          },
          '& .MuiButtonBase-root': {
            border: 'none',
            px: 1,
            py: 2,
          },
        },
        sx,
      )}
    >
      {undefinedLabel && (
        <Chip
          className="TagLabels-chip"
          label={undefinedLabel}
          size={size}
          color="primary"
          clickable={clickable}
          onClick={clickable ? handleChange(undefined) : undefined}
          sx={{
            backgroundColor: !currentTag ? '#00ACFF' : '#F3F5F8',
            color: !currentTag ? '#fff' : '#4E5052',
            ':hover': {
              backgroundColor: !currentTag ? '#00ACFF' : '#F3F5F8',
            },
          }}
        />
      )}

      {tags.map((tag) => (
        <Chip
          className="TagLabels-chip"
          key={tag}
          label={tag}
          size={size}
          color="primary"
          component="a"
          clickable={clickable}
          onClick={clickable ? handleChange(tag as any) : undefined}
          sx={{
            backgroundColor: currentTag === tag ? '#00ACFF' : '#F3F5F8',
            color: currentTag === tag ? '#fff' : '#4E5052',
            fontSize: '0.875rem',
            ':hover': {
              backgroundColor: currentTag === tag ? '#00ACFF' : '#F3F5F8',
            },
            '&.MuiButtonBase-root > span': {
              px: '12px',
            },
          }}
        />
      ))}
    </Box>
  );
}
